module.exports = __webpack_public_path__ + "static/media/ok-status-icon.a40ffb2d.svg";